import React from 'react';
import PropTypes from "prop-types";
import {useSelector, useDispatch} from "react-redux";
import {closeDrawer} from "../../actions/drawerActions";
import QuestionEditor from "../qd/questions/QuestionEditorHook";
import {createQuestionTemplateAndCloseDrawer, saveQuestionTemplateAndCloseDrawer} from "../../actions/questionTemplateActions";
import * as TEMPLATE from "../../constants/templateConstants";
import ArgoAppBarHook from "../common/ArgoAppBarHook";
import {createEditorOrigin, EDITOR_TYPES} from "../../utilities/editorInstanceOwnership";

const QUESTION_DEPTH = 0;

const QuestionCreateEditDrawer = ({ 
    createMode = false,
    templateKey = "",
    templateId = null,
    templateMode = "",
    setLoadingState,
    row,
    filter
}) => {
    const dispatch = useDispatch();
    const versionsFilter = useSelector(state => state.filter[TEMPLATE.FILTER.current.question]);
    const versionsFilterState = useSelector(state => state.filter[TEMPLATE.FILTER.versions.question]);
    const drawerStack = useSelector(state => state.drawerStack)
    const editorInstanceId = useSelector(
        state => state.questionEditor[QUESTION_DEPTH]?.instanceId
    );

    const handleCloseDrawer = () => {
        dispatch(closeDrawer());
    };

    const onCreateSuccess = () => {
        // Navigation handled by withRouter in parent component
    };

    const save = (questionTemplate) => {
        const requestOwner = createEditorOrigin(
            EDITOR_TYPES.QUESTION,
            editorInstanceId,
            QUESTION_DEPTH
        );
        if (createMode) {
            return dispatch(createQuestionTemplateAndCloseDrawer(
                questionTemplate,
                QUESTION_DEPTH,
                versionsFilter,
                onCreateSuccess,
                requestOwner
            ));
        }
        return dispatch(saveQuestionTemplateAndCloseDrawer(
            questionTemplate,
            filter,
            versionsFilter,
            templateMode,
            versionsFilterState,
            requestOwner
        ));
    };

    const handleRequestSave = (questionTemplate) => {
        if ((typeof setLoadingState === "function") && (templateMode !== "versions")) {
            return setLoadingState(save, questionTemplate);
        }
        return save(questionTemplate);
    };

    return (
        <div id="QuestionCreateEditDrawer-container-div" style={{height: "100%"}}>
            <ArgoAppBarHook
                title={drawerStack.displayTitle}
                showMenuIconButton={false}
                noIcon={true}
                isDrawer={true}
                width={questionCreateEditDrawerProps.width}
            />

            <div style={{height: '64px'}}></div>

            <QuestionEditor
                createMode={createMode}
                cancel={handleCloseDrawer}
                save={handleRequestSave}
                questionDepth={QUESTION_DEPTH}
                row={row}
                templateKey={templateKey}
                templateId={templateId}
                templateMode={templateMode}
                width={questionCreateEditDrawerProps.width}
                scrollTo="QuestionCreateEditDrawer-container-div"
            />
        </div>
    );
};

QuestionCreateEditDrawer.defaultProps = {
    createMode: false,
    templateKey: "",
    templateId: null,
    templateMode: "",
};

QuestionCreateEditDrawer.propTypes = {
    createMode: PropTypes.bool,
    setLoadingState: PropTypes.func,
    row: PropTypes.object,
    templateKey: PropTypes.string,
    templateId: PropTypes.number,
    templateMode: PropTypes.string,
    filter: PropTypes.object
};

const questionCreateEditDrawerProps = {
    opensecondary: true,
    width: "90%",
    docked: false,
    anchor: "right",
    setLoadingState: PropTypes.func,
};

export default QuestionCreateEditDrawer;
export {questionCreateEditDrawerProps};
